import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bedding_pillows: FaireCategoryEntity = {
  token: "cat_bedding-pillows",
  type: "category",
  name: "Pillows & pillowcases",
  level: 3,
  parentToken: "cat_home-decor-bedding",
  href: "/category/home-decor/bedding/pillows-pillowcases",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
